import React, { useEffect, useRef, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import rawStyles from "../../styles";
import mapImg from "../../../../assets/images/map.png";
import Statistis from "./Statistics";
import ImageCarousel from "./ImageCarousel";
import MapsView from "./MapsView";
import { useTheme } from "@emotion/react";

export default function ProjectOverview({ details }) {
  const [showLargeMap, setShowLargeMap] = useState(false);
  const largeMapRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const styles = rawStyles(isMobile);

  useEffect(() => {
    if (showLargeMap && largeMapRef.current) {
      largeMapRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [showLargeMap]);

  const smallMapContainerStyle = {
    width: isMobile ? "30vw" : "200px",
    height: isMobile ? "80px" : "120px",
    borderRadius: "12px",
    pointerEvents: "none",
  };

  const largeMapContainerStyle = {
    width: "100%",
    height: "25vh",
    borderRadius: "12px",
    marginTop: "10px",
  };

  return (
    <>
      <div style={{ ...styles.overview_section, isMobile }}>
        <div style={{ ...styles.section_1, ...styles.columnFlex }}>
          <ImageCarousel details={details} />
          <Statistis details={details} />

          <div style={styles.infoGrid}>
            <div style={{ ...styles.columnFlex, gap: "5px" }}>
              <h3 style={styles.section_heading}>Location:</h3>
              <div style={styles.section_sub_heading}>
                {details?.location || "-"}
              </div>
            </div>
            <div style={{ ...styles.columnFlex, gap: "5px" }}>
              <h3 style={styles.section_heading}>Client Type:</h3>
              <div style={styles.section_sub_heading}>
                {details?.client_type || "-"}
              </div>
            </div>
            <div style={{ ...styles.columnFlex, gap: "5px" }}>
              <h3 style={styles.section_heading}>Scope:</h3>
              <div style={styles.section_sub_heading}>
                {details?.scope || "-"}
              </div>
            </div>
            <div style={{ ...styles.columnFlex, gap: "5px" }}>
              <h3 style={styles.section_heading}>Unit Type:</h3>
              <div style={styles.section_sub_heading}>
                {details?.unit_type || "-"}
              </div>
            </div>
            <div style={{ ...styles.columnFlex, gap: "5px" }}>
              <h3 style={styles.section_heading}>Unit:</h3>
              <div style={styles.section_sub_heading}>
                {details?.unit || "-"}
              </div>
            </div>
            <div style={{ ...styles.columnFlex, gap: "5px" }}>
              <h3 style={styles.section_heading}>Unit Size:</h3>
              <div style={styles.section_sub_heading}>
                {details?.unit_size || "-"}
              </div>
            </div>
          </div>
          <div style={{ ...styles.columnFlex, marginTop: "1vh" }}>
            <div style={styles.section_heading}>Description</div>
            <h3 style={styles.section_sub_heading}>{details?.description}</h3>
          </div>
        </div>

        {isMobile && (
          <div
            style={{
              borderTop: "1px solid #D7D8D9",
              width: "100%",
              margin: "16px 0",
            }}
          />
        )}

        <div style={{ ...styles.section_2, ...styles.columnFlex, gap: "20px" }}>
          <div style={styles.section_heading}>Members</div>
          <div style={styles.columnFlex}>
            <h3 style={styles.section_sub_heading}>Customer</h3>
            <Box display="flex" alignItems="center">
              {details?.user_data && (
                <Box
                  component="img"
                  src={
                    details?.user_data?.profile_url ||
                    "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                  }
                  alt="Customer Icon"
                  sx={{
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                    boxShadow: "0px 4px 2.67px 0px #00000026",
                    marginRight: 1,
                  }}
                />
              )}
              {details?.user_data?.username}
            </Box>
          </div>

          <div style={styles.columnFlex}>
            <h3 style={styles.section_sub_heading}>Contractor</h3>
            <Box display="flex" alignItems="center">
              {details?.Contractor && (
                <Box
                  component="img"
                  src={
                    details?.Contractor?.profile_url ||
                    "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                  }
                  alt="Contractor Icon"
                  sx={{
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                    boxShadow: "0px 4px 2.67px 0px #00000026",
                    marginRight: 1,
                  }}
                />
              )}
              {details?.Contractor?.company_name}
            </Box>
          </div>

          <div style={{ ...styles.columnFlex, marginTop: "2vh" }}>
            <div style={styles.section_heading}>Location</div>
            <div
              style={{
                ...styles.location,
                ...styles.rowFlex,
                gap: "10px",
                justifyContent: "space-between",
              }}
            >
              <p style={{fontSize: isMobile ? "12px" : "14px"}}>{details?.location || "N/A"}</p>
              {details?.lat !== null && details?.lng !== null ? (
                <div
                  onClick={() => setShowLargeMap(!showLargeMap)}
                  style={{ cursor: "pointer", display: "inline-block" }}
                >
                  <MapsView
                    details={details}
                    mapContainerStyle={smallMapContainerStyle}
                    interactive={false}
                  />
                </div>
              ) : (
                <Box
                  component="img"
                  sx={{
                    height: isMobile ? 150 : 75,
                    width: isMobile ? "80vw" : 120,
                  }}
                  src={mapImg}
                />
              )}
            </div>
            {showLargeMap && (
              <div ref={largeMapRef}>
                <MapsView
                  details={details}
                  mapContainerStyle={largeMapContainerStyle}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
